import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { C, PageHeader, Button, Skeleton } from "@coremonit/design-system";
import { ArrowLeft, GitBranch } from "lucide-react";
import { useDeploymentTimeline, useService } from "../api/hooks";
import { DeploymentViewer } from "../components/DeploymentViewer";
import { Breadcrumbs } from "../components/Breadcrumbs";

export function DeploymentViewerPage() {
  const { id: serviceId, deploymentId } = useParams<{ id: string; deploymentId: string }>();
  const nav = useNavigate();
  const service = useService(serviceId);
  const timeline = useDeploymentTimeline(serviceId);

  const entry = useMemo(
    () => timeline.data?.items.find((e) => e.id === deploymentId),
    [timeline.data, deploymentId],
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <Breadcrumbs items={[
        { label: "Services", path: "/services" },
        { label: service.data?.name ?? "Service", path: serviceId ? `/services/${serviceId}` : undefined },
        { label: "Deployments", path: serviceId ? `/services/${serviceId}?tab=deployments` : undefined },
        { label: entry?.revision ?? "Deployment" },
      ]} />
      <PageHeader
        icon={<GitBranch size={16} />}
        title={entry ? `${entry.serviceName} · ${entry.revision}` : "Deployment viewer"}
        subtitle={entry ? `${entry.imageTag} · ${entry.strategy.replace("_", " ")} · ${entry.success ? "Success" : "Failed"}` : "Loading…"}
        actions={
          <Button variant="ghost" icon={<ArrowLeft size={12} />} onClick={() => nav(`/services/${serviceId}?tab=deployments`)}>
            Back to service
          </Button>
        }
      />

      {timeline.isLoading || !entry ? (
        <Skeleton height={480} radius={16} />
      ) : (
        <DeploymentViewer entry={entry} />
      )}
    </div>
  );
}
